import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';
import { pick } from 'lodash';

import { navSections, useRegisterSection } from 'components/OnePageTemplates/common';
import { useDataContext } from 'components/OnePageTemplates/context';

import { hasMeaningfulValues } from 'helpers/hasMeaningfulValues';

import { LargeCard } from '../components/LargeCard';

import styles from './ProductsAndServicedSection.module.scss';

export const ProductsAndServicedSection: React.FC = () => {
  const { data } = useDataContext();
  const { t } = useTranslation();
  const registerNavSection = useRegisterSection(navSections.productsAndServices);

  const sectionData = pick(data, ['mainProductsOrServices', 'competitionAdvantage']);

  if (!hasMeaningfulValues(sectionData)) {
    return null;
  }

  return (
    <Box {...registerNavSection} className={styles.section}>
      <Box className={styles.wrapper}>
        <Box className={styles.productsAndServicesSection}>
          <Box className={styles.title}>{t('chapters.FOR_BANK_PRODUCTS_AND_SERVICES')}</Box>
          {data.mainProductsOrServices && (
            <LargeCard
              title={t('onePageMapping.mainProdOffered')}
              content={data.mainProductsOrServices}
              variant="transparent"
              className={styles.card}
            />
          )}
          {data.competitionAdvantage && (
            <LargeCard
              title={t('onePageMapping.uniqueFeatures')}
              content={data.competitionAdvantage}
              variant="transparent"
              className={styles.card}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};
